import { Divider, List, makeStyles } from "@material-ui/core";
import { AssignmentInd, Book, Dashboard, Person, Room, School, Star } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";
import { ApplicationState } from "../..";
import { routesPaths } from "../../Routes";
import { useGetMeQuery } from "../../api/rtk/MeApi";
import { PersonType } from "../../model/PersonType";
import { SessionState } from "../../store/session/SessionState";
import { ActionCreators } from "../../store/session/SessionStore";
import Logout from "../login/Logout";
import ListItemLink from "./ListItemLink";
import CoursesLogo from "./img/CoursesLogo.svg";
import ModulesLogo from "./img/ModulesLogo.svg";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { SkipToken, skipToken } from "@reduxjs/toolkit/dist/query";
import { InteractionStatus } from "@azure/msal-browser";

type NavigationListProps = SessionState & typeof ActionCreators;

const useStyles = makeStyles((theme) => ({
  list: {
    [theme.breakpoints.up("sm")]: {
      paddingLeft: "8px",
    },
  },
}));

const NavigationList: React.FC<NavigationListProps> = () => {
  const cssClasses = useStyles();
  const [skipTokenState, setSkipTokenState] = useState<SkipToken | undefined>(skipToken);
  const { data: me, isFetching: isMeFetching } = useGetMeQuery(skipTokenState);
  const { instance, inProgress} = useMsal();

  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated && inProgress === InteractionStatus.None) {
      setSkipTokenState(undefined);
    }
  }, [inProgress, isAuthenticated]);

  if (isMeFetching) {
    return <React.Fragment />;
  }

  return (
    <React.Fragment>
      <List className={cssClasses.list}>
        <ListItemLink to={routesPaths.userProfile()} translationKey="home.me.edit">
          <Person />
        </ListItemLink>
        {me?.type !== PersonType.Internal && (
          <ListItemLink to={routesPaths.candidateHome()} translationKey="home.candidate">
            <School />
          </ListItemLink>
        )}
        {me?.type === PersonType.Expert && (
          <ListItemLink to={routesPaths.expertHome()} translationKey="home.expert">
            <Star />
          </ListItemLink>
        )}
        {me?.type === PersonType.Internal && (
          <ListItemLink to={routesPaths.root()} translationKey="home.header">
            <Dashboard />
          </ListItemLink>
        )}
        {me?.type === PersonType.Internal && (
          <ListItemLink to={routesPaths.candidates()} translationKey="candidate.header">
            <School />
          </ListItemLink>
        )}
        {me?.type === PersonType.Internal && (
          <ListItemLink to={routesPaths.locations()} translationKey="location.header">
            <Room />
          </ListItemLink>
        )}
        {me?.type === PersonType.Internal && (
          <ListItemLink to={routesPaths.examSessions()} translationKey="examSession.header">
            <AssignmentInd />
          </ListItemLink>
        )}
      </List>
      <Divider />
      {me?.type === PersonType.Internal && (
        <>
          <List className={cssClasses.list}>
            <ListItemLink to={routesPaths.courses()} translationKey="courseManagement.header">
              <img src={CoursesLogo} alt="" style={{ marginLeft: 3, width: 20 }} />
            </ListItemLink>
            <ListItemLink to={routesPaths.modules()} translationKey="module.header">
              <img src={ModulesLogo} alt="" style={{ marginLeft: 3, width: 20 }} />
            </ListItemLink>
            <ListItemLink to={routesPaths.exams()} translationKey="examManagement.header">
              <Book />
            </ListItemLink>
          </List>
          <Divider />
        </>
      )}
      <List className={cssClasses.list}>
        <Logout
          logout={() => {
            sessionStorage.clear();
            instance.logoutRedirect({
              account: instance.getActiveAccount(),
              postLogoutRedirectUri: instance.getConfiguration()?.auth?.redirectUri
            })
          }}
        />
      </List>
    </React.Fragment>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({ ...ActionCreators }, dispatch);

export default connect((state: ApplicationState) => state.sessionState, mapDispatchToProps)(NavigationList);
